export default function(value, alt) {
  if (!value) return alt;
  return value;
}
